module.exports = __webpack_public_path__ + "media/32.804956cd.mp3";